export default __webpack_public_path__ + "static/media/Pizza.b1832dc7.jpg";